__webpack_require__.p = "https://allgk.ru/";